export const globalSettingsIssuesPrioritiesTranslationsRoute = {
	name: 'global-settings-issues-priorities-translations',
	path: '/secure/admin/ViewTranslations!default.jspa',
	query: ['issueConstantType=priority'],
};
